import { render, staticRenderFns } from "./Batchfile.vue?vue&type=template&id=4cbf99e7&scoped=true"
import script from "./Batchfile.vue?vue&type=script&lang=js"
export * from "./Batchfile.vue?vue&type=script&lang=js"
import style0 from "./Batchfile.vue?vue&type=style&index=0&id=4cbf99e7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cbf99e7",
  null
  
)

export default component.exports